import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=10fc0e1e&scoped=true&"
import script from "./whiteList.vue?vue&type=script&lang=js&"
export * from "./whiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc0e1e",
  null
  
)

export default component.exports